import React from "react";
import _DetailMessageTemplate from "../../../features/partner/rcs/components/detail/_DetailMessageTemplate";
const DetailMessageTemplate = () => {
  return (
    <div>
     <h4 className="font-semibold">Detalles de Mensaje RCS</h4>
      <_DetailMessageTemplate />
    </div>
  );
};

export default DetailMessageTemplate;
